import React, { PureComponent } from 'react';
import { Exports as ExportsModule } from '@dev/ee-modules';
import { withTranslation } from 'react-i18next';
import { replace as Replace } from 'redux-first-history';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { withRouter } from 'react-router';
import { ApplicationState as State } from '../../store';
import dayjs from '../../services/tools/dayjs';
import { ExportsPayload } from '../../store/exports/types';
import ExportsProps, { ExportState } from './ExportsInterface';
import {
    LoadExports,
    FilterExports,
    DeleteExport,
    SearchExports,
    RestoreDefaultStore,
    CancelPollingExports,
} from '../../store/exports/actions';
import { ShowDialogParams } from '../../store/dialog/types';
import { ShowDialog } from '../../store/dialog/actions';

const mapState = (state: State, ownProps: ExportsProps): ExportsProps => ({
    ...ownProps,
    browser: state.browser,
    exports: state.exports,
});
interface DispatchProps {
    LoadExports(params?: ExportsPayload): void;
    FilterExports(params?: ExportsPayload): void;
    SearchExports(params?: ExportsPayload): void;
    ShowDialog: (params?: ShowDialogParams) => void;
    DeleteExport: (id: string) => void;
    Replace(url: string | Record<string, string>): void;
    RestoreDefaultStore(): void;
    CancelPollingExports(): void;
}

const dispatchProps = {
    LoadExports,
    FilterExports,
    SearchExports,
    ShowDialog,
    DeleteExport,
    Replace,
    RestoreDefaultStore,
    CancelPollingExports,
};

type Props = DispatchProps & ExportsProps;
class Exports extends PureComponent<Props, ExportState> {
    componentWillUnmount() {
        this.props.RestoreDefaultStore();
        this.props.CancelPollingExports();
    }

    public render(): JSX.Element {
        return <ExportsModule {...this.props} dayjs={dayjs} />;
    }
}

export default compose(
    withRouter,
    withTranslation(),
    connect<ExportsProps, DispatchProps>(mapState, dispatchProps)
)(Exports);
